var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnFloorplanLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 21.25H22.75V22.75H11.25V21.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 32.75L21.25 11.25L22.75 11.25L22.75 32.75H21.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 15C11.25 12.9289 12.9289 11.25 15 11.25H29C31.0711 11.25 32.75 12.9289 32.75 15V29C32.75 31.0711 31.0711 32.75 29 32.75H15C12.9289 32.75 11.25 31.0711 11.25 29V15ZM15 12.75C13.7574 12.75 12.75 13.7574 12.75 15V29C12.75 30.2426 13.7574 31.25 15 31.25H29C30.2426 31.25 31.25 30.2426 31.25 29V15C31.25 13.7574 30.2426 12.75 29 12.75H15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFloorplanLight);
export default __webpack_public_path__ + "static/media/btn_floorplan_light.89fb4c2d8061acf6459bd20e89017052.svg";
export { ForwardRef as ReactComponent };